module.exports = __webpack_public_path__ + "media/images/icon-contact-dots-white-c52512b095f5b633052021e8d68b6b8e.svg";